<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" :append-to-body="true" width="830px">
        <el-form ref="form" :model="dioForm" :rules="rules" inline>
            <el-col :span="12">
                <el-form-item>
                    <Tooltip class="inline-block" style="width:400px" v-if="choozeArray.length" :text="tipText">
                        <span>
                            <el-tag class="icon-margin" effect="dark" v-for="trigger in choozeArray" :key="trigger.id">{{
                                trigger.name }}</el-tag>
                        </span>
                    </Tooltip>

                    <span v-else>
                        {{ $t('integration.please_select_trigger') }}
                    </span>
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item :label="$t('public.trigger')" prop="name">
                    <el-input v-model.trim="dioForm.name" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="formBtn" icon="el-icon-search" @click="searchFn"></el-button>
                    <i class="el-icon-s-tools" @click="setingFn" :title="`${$t('public.btn_add')} ${$t('public.trigger')}`"></i>
                </el-form-item>
            </el-col>
        </el-form>
        <el-table stripe :height="400" v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark"
            style="width: 100%" :show-header="false" @selection-change="handleSelectionChange"
            v-load-more.expand="{ func: loadmore, target: '.el-table__body-wrapper', delay: 500 }"
            :load-more-disabled="disabledLoad">
            <el-table-column type="selection" width="55" />

            <el-table-column prop="name" show-overflow-tooltip />

            <el-table-column :prop="$t('integration.operation')" width="60">
                <template #default="{ row }">
                    <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.details')"
                        v-has="['uptRange']" @click="detailFn(row)"></el-button>
                </template>
            </el-table-column>
            <div slot="append" style="text-align:center;">{{ disabledLoadFn() }}</div>
        </el-table>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
        <!-- 详情&编辑 -->
        <alarmSet :title="setTitle" :isShow.sync="isShow" :detailObj="alarmSeting" :rangeArray="rangeArray" ref="alarmSet"
            @confirm="confirm" />
        <!-- :rangeArray="rangeArray" -->
        <!-- 新增报警触发 -->
        <addAlarm :scopeId="scopeId" :isShowAdd.sync="isShowAdd" :rangeArray="rangeArray" @getAgainFn="getAgainFn"
            :title="addTitle" :ParenList="ContactsList" ref="addAlarm" />
        <!-- :rangeArray="rangeArray" -->
    </modal>
</template>

<script>

import alarmSet from './AlarmSeting.vue'
import addAlarm from './AddAlarm.vue'
import Tooltip from '../../../system/resource/components/tooltip.vue'
// 报警设置的api
import { alarmTriggerDetail, alarmContactsList, saveCarrierAlarmTrigger } from '@/api/modules/alarm.js'
import mixinRange from '@/utils/getRange.js'
export default {
  mixins: [mixinRange],
  props: ['isAlarm', 'title', 'detailObj', 'loading', 'tableData', 'disabledLoad', 'choozeTable', 'scene'],
  components: {
    alarmSet,
    addAlarm,
    Tooltip
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isAlarm
      },
      set: function (val) {
        this.$emit('update:isAlarm', val) // 可以优化成model  或者minx
      }
    },
    rules () {
      return {}
    },
    tipText () {
      return this.choozeArray.map(item => item.name).join(',')
    }
  },
  watch: {
    choozeTable (newVal) {
      if (!newVal || !this.$refs.multipleTable) return

      this.tableData.forEach(item => {
        this.$refs.multipleTable.toggleRowSelection(item, false)
      })
      for (var i = 0; i < newVal.length; i++) {
        for (var j = 0; j < this.tableData.length; j++) {
          if (this.tableData[j].id === (newVal[i].alarmTriggerId || newVal[i].id)) {
            this.$refs.multipleTable.toggleRowSelection(this.tableData[j], true)
          }
        }
      }
    }
  },
  data () {
    return {
      dioForm: {
        name: ''
      },
      isShow: false,
      setTitle: '',
      alarmSeting: {},
      isShowAdd: false,
      addTitle: '',
      rangeArray: [],
      // 联系人数组
      ContactsList: [],
      // 勾选的表格
      choozeArray: [],
      // 贯穿所有的层级范围id
      scopeId: ''
    }
  },
  created () {
    // this.getRangeFn();
    this.getCustomerList({ tab: 1, type: 1 }).then(({ result }) => {
      this.rangeArray = result
    })
  },
  methods: {
    getRangeFn () {
      this.getCustomerList({
        type: 1,
        tab: 1
      }).then(({ result }) => {
      })
    },
    disabledLoadFn () {
      return this.disabledLoad ? $t('integration.no_more') : $t('integration.scroll_to_the_bottom_to_load_more')
    },
    handleSave () {
      if (!this.detailObj || !this.detailObj.id) {
        const trigger = this.choozeArray.map(item => {
          item.alarmTriggerId = item.id
          return item
        })
        // 这里不能删啊  分别要在新增监测点 监测点列表 监测点详情使用到 这里只是在新增监测点使用
        this.$emit('confirm', this.choozeArray)
        this.$emit('update:isAlarm', false)
        return
      }
      const alarmTriggerList = this.choozeArray.map(item => item.id)
      const query = {
        alarmTriggerList,
        carrierIdList: this.detailObj.id
      }
      saveCarrierAlarmTrigger(query).then(({ state }) => {
        if (state.code === 200) {
          this.isShowDialog = false
          this.$message.success($t('integration.saved_successfully'))
          this.$emit('getList')
        } else {
          this.$message.success($t('integration.save_failed'))
        }
      })
    },
    loadmore () {
      this.$parent.dioForm.iDisplayStart += 13
      this.$parent.getListFn()
    },
    searchFn (str) {
      this.$parent.dioForm.iDisplayStart = 0
      this.$parent.dioForm.name = this.dioForm.name
      this.$parent.getListFn()
    },
    getAgainFn () {
      this.$parent.dioForm.iDisplayStart = 0
      this.$parent.dioForm.name = this.dioForm.name
      this.$parent.tableData = []
      this.$parent.getListFn()
    },
    setingFn () {
      this.isShowAdd = true
      this.addTitle = $t('alarm.add_trigger')
      // this.getRange();
      this.getAlarmContactsList()
      this.$nextTick(() => {
        this.$refs.addAlarm.resetFn()
      })
      this.scopeId = (this.detailObj && this.detailObj.scene_id) || this.scene
    },
    getAlarmContactsList () {
      alarmContactsList({ sceneId: (this.detailObj && this.detailObj.scene_id) || this.scene }).then(({ result }) => {
        this.ContactsList = result
      })
    },
    // getRange() {
    //     if (this.rangeArray.length > 0) return;
    //     accessRangeTree({ code: 'scope', type: 1 }).then(({ result }) => {
    //         console.log(result);
    //         this.rangeArray = result;
    //     });
    // },
    handleSelectionChange (arg) {
      this.choozeArray = arg
    },
    detailFn (row) {
      this.isShow = true
      this.setTitle = `[${row.name}]${$t('integration.trigger_name_')}`
      this.getAlarmContactsList()
      this.$nextTick(() => {
        this.$refs.alarmSet.resetFn()
      })
      this.getDetailFn(row)
    },
    getDetailFn (row) {
      alarmTriggerDetail(row.id).then(({ result }) => {
        this.alarmSeting = result
      })
    },
    confirm (query) {
      // 确认修改成功时更新触发器名称
      this.tableData.forEach(item => {
        if (item.id === query.id) {
          item.name = query.name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
i {
    cursor: pointer;
}

.pageTion {
    text-align: center;
    margin-top: 15px;

    .iconNotAllow {
        cursor: not-allowed;
    }
}

::v-deep .el-table {
    &::before {
        height: 0;
    }
}

.pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>
